import type { AdditionalContent } from '@/types/additionalContent';
import { isTourConfig } from '@/types/additionalContent';

const DEFAULT_SELECTOR = 'body';

type Position = 'top' | 'bottom' | 'left' | 'right' | 'center';

export interface TourStepInput {
  selector: string;
  position?: Position;
  additionalContent: AdditionalContent;
}

/**
 * Transforms AdditionalContent items to @reactour/tour step inputs.
 * Content is already slot-specific (caller fetches by slot). Optional page filter.
 * Maps json.targetSelector → selector, json.placement → position.
 */
export function transformToTourSteps(
  content: AdditionalContent[],
  pageFilter?: string
): TourStepInput[] {
  const filtered = content.filter((c) => !pageFilter || c.page === pageFilter);
  const sorted = [...filtered].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return sorted.map((item) => {
    let json = item.json;
    if (typeof json === 'string') {
      try {
        json = JSON.parse(json) as Record<string, unknown>;
      } catch {
        json = undefined;
      }
    }
    const config = typeof json === 'object' && json !== null && isTourConfig(json)
      ? json
      : null;

    const selector = config?.targetSelector ?? DEFAULT_SELECTOR;
    const position = (config?.placement ?? 'bottom') as Position;

    return {
      selector,
      position,
      additionalContent: item,
    };
  });
}
